var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"to":{name: 'Home'},"variant":"btn-link"}},[_c('BIconX',{attrs:{"icon":"x","font-scale":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }